import { useEffect, useLayoutEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { GlobalLoader } from '@components/loader';
import { Toast } from '@components/toast';
import { IS_SUBSCRIPTION_MANAGER_ENABLED } from '@stores/AuthStore';
import { useStore } from '@stores/RootStore';
import { useGetCategories } from '@queryHooks/useCategory';
import { useGetTenant } from '@queryHooks/useTenant';
import { Modals } from './common/modals';
import ManagerGnb from './manager/gnb/ManagerGnb';

// 구독 관리자에게 허용된 경로 패턴 (스토어 접근 불가)
// TODO: MZP2-5714 - SUBSCRIPTION_OWNER_ALLOWED_SUBMENUS와 통합 필요 (Subscription.tsx 참조)
const SUBSCRIPTION_OWNER_ALLOWED_PATHS = ['/subscriptions/list', '/subscriptions/user-mgmt'];

export const Manager = observer(() => {
  const location = useLocation();
  const { authStore, categoryStore } = useStore();

  const tenantId = location.pathname.split('/')[2];

  const { data: tenant } = useGetTenant(tenantId);

  useLayoutEffect(() => {
    if (tenant) {
      authStore.setManagerTenantInfo(tenant);
    }
  }, [authStore, tenant]);

  useLayoutEffect(() => {
    authStore.initialize(tenantId, false, true);
  }, [authStore, tenantId]);

  const { data: categories } = useGetCategories();

  useEffect(() => {
    if (categories && categories.content.length > 0) {
      categoryStore.setCategories(categories.content);
    }
  }, [categories, categoryStore]);

  // AuthStore 초기화 완료 전까지 로딩 표시 (깜빡임 방지)
  if (!authStore.isInitialized) {
    return <GlobalLoader />;
  }

  // 구독 관리자 전용인 경우 허용된 경로 외 접근 시 리다이렉트
  // KTDS 환경(VITE_ENABLE_SUBSCRIPTION_MANAGER=false)에서는 이 기능 비활성화
  if (IS_SUBSCRIPTION_MANAGER_ENABLED && tenantId && authStore.isSubscriptionOwnerOnly) {
    const currentPath = location.pathname;
    const basePath = `/manager/${tenantId}`;
    const relativePath = currentPath.replace(basePath, '');

    const isAllowedPath = SUBSCRIPTION_OWNER_ALLOWED_PATHS.some(allowed => relativePath.startsWith(allowed));

    if (!isAllowedPath) {
      return <Navigate to={`${basePath}/subscriptions/list`} replace />;
    }
  }

  return (
    <div className="app customer">
      <ManagerGnb />
      <Main>
        <ContentsWrapper>
          <Outlet />
        </ContentsWrapper>
      </Main>
      <Modals />
      <GlobalLoader />
      <Toast />
    </div>
  );
});

export const Main = styled.main`
  width: 100%;
  padding-top: var(--manager-gnb-height);
`;

export const ContentsWrapper = styled.div`
  height: 100%;
`;
